const routes = [
  // 预约首页
  {
    path: "/appointment",
    name: 'appointment',
    meta: {
      title: '预约',
      hasBack: false
    },
    component: () => import('@/pages/medical/medicalAppointment/appointment.vue'),
  },
  {
    path: "/appscanCode",
    name: 'appscanCode',
    meta: {
      title: '扫码预约',
      hasBack: false
    },
    component: () => import('@/pages/medical/medicalAppointment/scanCode.vue'),
  },
];
export default routes;
